export default __webpack_public_path__ + "static/media/SmartSlides.d8c90f74.png";